<template>
  <div class="page-auth">
    <div class="w-100 h-100 overflow-auto">
      <div class="row m-0">
        <div class="col-10 col-sm-8 col-md-6 col-lg-4 mx-auto login-form">
          <div class="login-form-header bg-dashboard-dark-1 p-2">
            <img src="@/assets/jkr-logo.png" />
            <p class="mb-0 mr-2 font-weight-bold text-white">FORGOT PASSWORD</p>
          </div>
          <div class="login-form-body bg-dashboard-dark-1">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <div
                  class="
                    input-group-text
                    rounded-0
                    bg-white
                    border-right-0
                    text-muted
                    pr-1
                    border-outline-dark
                    bg-dark-input
                  "
                  :class="{ 'border-danger': errors.email }"
                >
                  <font-awesome-icon :icon="['fas', 'at']" />
                </div>
              </div>
              <input
                type="text"
                class="
                  form-control
                  border-left-0 border-outline-dark
                  bg-dark-input
                  text-white
                "
                :class="{ 'border-danger': errors.email }"
                placeholder="Email"
                @keydown.enter="forgot()"
                v-model="models.email"
              />
            </div>
            <p class="small text-danger text-center" v-if="forgotError">
              Please enter your email address.
            </p>
            <button
              class="btn btn-block btn-login btn-primary rounded-0"
              @click="forgot()"
              :disabled="isProcessing"
            >
              <span>Send Email</span>
              <div
                class="spinner-border spinner-border-sm text-light"
                v-if="isProcessing"
              ></div>
            </button>
            <button
              type="button"
              class="btn btn-link w-100 mt-3"
              @click="goTo('auth')"
            >
              Back to login
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      isProcessing: false,
      forgotError: false,
      models: {
        email: "",
      },
      errors: {
        email: false,
      },
    };
  },
  methods: {
    forgot() {
      this.isProcessing = true;
      const hasError = this.verifyForm();
      if (!hasError) {
        API.forgetPassword("auth/forgot-password", this.models)
          .then((retVal) => {
            this.isProcessing = false;
            Swal.fire({
              title: "Success",
              text: "Email successfully send to " + this.models.email,
              icon: "success",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK",
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push({
                  name: "auth",
                });
              }
            });
          })
          .catch((err) => {
            console.error(err);
            this.isProcessing = false;
            Swal.fire(
              "User not found",
              "We cannot find user with email " + this.models.email,
              "error"
            );
          });
      } else {
        this.isProcessing = false;
      }
    },
    verifyForm() {
      this.forgotError = false;
      for (let index = 0; index < Object.keys(this.models).length; index++) {
        const key = Object.keys(this.models)[index];
        const model = this.models[key];

        if (!model) {
          this.errors[key] = true;
          this.forgotError = true;
        } else {
          this.errors[key] = false;
        }
      }
      return this.forgotError;
    },
    goTo(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>
